// Dev-only logging — silent in production builds so no debugging
// information (or accidentally sensitive payloads) leaks to end users.
const isDev = process.env.NODE_ENV !== 'production';

export const logWarn = (...args) => { if (isDev) console.warn(...args); };
export const logError = (...args) => { if (isDev) console.error(...args); };
